<template>
  <div class="flex flex-col my-4">
    <div v-for="category in categories" :key="category">
      <p class="text-xl font-medium">{{category}}</p>
      <div
        v-for="(subCategory,i) in subCategories[category]"
        :key="`${subCategory.name}-${i}`"
        v-show="filteredItems(category, subCategory.name).length > 0"
        class="pl-8"
      >
        <p class="text-xl font-medium">{{subCategory.name}}</p>
        <div
          v-for="(item,i) in filteredItems(category, subCategory.name)"
          :key="`${item.name}-${i}`"
          @click="$emit('item-to-edit', item)"
          class="pl-8 cursor-pointer hover:underline"
        >
          {{item.name}}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'EditItemPicker',
  props: {
    items: {
      type: Array,
      required: true,
    },
    categories: {
      type: Array,
      requied: true,
    },
    subCategories: {
      type: Object,
      requied: true,
    },
  },
  methods: {
    filteredItems(category, subCategory) {
      return this.items.filter((item) => item.category === category && item.subCategory === subCategory);
    },
  },
};
</script>
